module.exports = __webpack_public_path__ + "img/postervideo.29df5be7.png";